import React from 'react';
import { OfferBanner } from '../components/OfferBanner';
import { HeroSection } from '../components/HeroSection';
import { EmotionalConnection } from '../components/EmotionalConnection';
import { AvatarPains } from '../components/AvatarPains';
import { SolutionBenefits } from '../components/SolutionBenefits';
import { ProductOffer } from '../components/ProductOffer';
import { Bonuses } from '../components/Bonuses';
import { BreedGallery } from '../components/BreedGallery';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { FloatingCTA } from '../components/FloatingCTA';
export function LandingPage() {
  return <div className="min-h-screen font-body text-deep-brown selection:bg-soft-rose selection:text-white" data-id="element-372">
      <OfferBanner data-id="element-373" />
      <main data-id="element-374">
        <HeroSection data-id="element-375" />
        <EmotionalConnection data-id="element-376" />
        <AvatarPains data-id="element-377" />
        <SolutionBenefits data-id="element-378" />
        <BreedGallery data-id="element-379" />
        <ProductOffer data-id="element-380" />
        <Bonuses data-id="element-381" />
        <Testimonials data-id="element-382" />
        <FAQ data-id="element-383" />
      </main>
      <Footer data-id="element-384" />
      <FloatingCTA data-id="element-385" />
    </div>;
}